import styled from 'styled-components';
import { visuallyHiddenStyles } from 'modules/VisuallyHidden';
import { theme } from 'modules/tetrisTheme';
export const Container = styled.a `
  padding: 0;
  font-size: ${theme.fontSize.medium};
  font-weight: ${theme.fontWeight.semibold};
  line-height: ${theme.lineHeight.none};
  ${visuallyHiddenStyles};
  text-decoration: none;
  text-transform: uppercase;
  color: ${theme.swatches.warm[500]};

  &:focus-visible {
    padding: ${theme.spacing.md};
    position: fixed;
    top: ${theme.spacing.xl};
    left: ${theme.spacing.xl};
    width: auto;
    height: auto;
    z-index: 100;
    background: ${theme.semantic.surface.primary};
    clip: auto;
    outline: none;
  }
`;
